import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { BreakdownAnalysisTableComponent } from '../../../../../_shared/components/breakdown-analysis-table/breakdown-analysis-table.component';
import { MaintenanceOverviewService } from '../../../services/maintenance-overview.service';
import { BreakdownAnalysisRequest } from '../../../models/maintenance-overview-request.model';
import { BreakdownAnalysisResponse } from '../../../models/maintenance-overview.model';
import { ErrorHandlerService } from '../../../../../../_shared/services/error-handler.service';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-in-maintenance-modal',
  standalone: true,
  imports: [CommonModule, BreakdownAnalysisTableComponent, TranslocoPipe],
  templateUrl: './in-maintenance-modal.component.html',
  styleUrl: './in-maintenance-modal.component.scss'
})
export class InMaintenanceModalComponent implements OnInit {
  isLoading: boolean = false;
  data: BreakdownAnalysisResponse[] = [];

  private maintenanceOverviewService = inject(MaintenanceOverviewService);
  private errorService = inject(ErrorHandlerService);
  private cancelSubject = new Subject<void>();

  constructor(private activeModal: NgbActiveModal) { }

  async ngOnInit(): Promise<void> {
    await this.loadData();
  }

  async loadData(): Promise<void> {
    this.isLoading = true;

    try {
      const request: BreakdownAnalysisRequest = {
        accountIds: [],
        timeFrom: new Date(),
        timeTo: new Date()
      };

      const response = await this.maintenanceOverviewService.getInMaintenanceBreakdown(request, this.cancelSubject);
      if (response.data) {
        this.data = response.data;
      }

      this.isLoading = false;
    } catch (error) {
      this.errorService.handleError(error, {
        callback: () => {
          this.isLoading = false;
        }
      });
    }
  }

  closeModal(): void {
    this.cancelSubject.next();
    this.cancelSubject.complete();
    if (this.activeModal) {
      this.activeModal.close();
    }
  }
}